module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-right-3071b503023812b7fdc708b4c253dc13.svg";